"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.templatesSearchParamsCreator = void 0;
const types_1 = require("@framework/types");
const types_2 = require("../types");
const templatesSearchParamsCreator = profile => ({
    [types_2.ServiceType.ADMIN]: {
        templateStatus: [types_1.TemplateStatus.ACTIVE],
        contractIds: [],
    },
    [types_2.ServiceType.OFFICE]: {
        templateStatus: [types_1.TemplateStatus.ACTIVE],
        contractIds: [],
        merchantId: profile.merchantId,
    },
});
exports.templatesSearchParamsCreator = templatesSearchParamsCreator;
//# sourceMappingURL=templates-search-params.js.map